import React from 'react';
import '../../../assets/css/pages/news.css';
import useScroll from '../../../core/custom-hooks/useScroll';
import { useTranslation } from 'react-i18next';
import { NewVM } from '../../../core/models/news.model';

interface Props {
  newsDetail: NewVM;
}

const NewsDetailV2: React.FC<Props> = ({ newsDetail }) => {
  useScroll();
  const { t } = useTranslation(['common']);

  const getCategory = (newsItem: NewVM) => {
    if (newsItem.category && newsItem.category.length > 0) {
      return newsItem.category[0].name;
    }
    return '';
  };

  const getUpdateDate = () => {
    if (newsDetail.updatedAt) {
      const tempDateSplit = newsDetail.updatedAt.split('T');
      return tempDateSplit[0];
    }
    return '';
  };

  const renderNewsDetail = (): React.ReactElement => {
    if (newsDetail.id) {
      return (
        <div className="text-dark-custom mt-5 mt-md-2">
          <div className="container pb-5">
            {/* <p className=" pt-2 mb-3">
              <i>
                {t('published')} {getUpdateDate()}
              </i>
            </p> */}
            <h3>
              <b>{getCategory(newsDetail)}</b>
            </h3>
            <h1 className="title v2 v3 pt-2 mb-4">
              <b>{newsDetail.title || ''}</b>
            </h1>
            <p
              style={{ whiteSpace: 'pre-line', fontWeight : 'bold' }}
              className="news-content-v2"
              dangerouslySetInnerHTML={{ __html: newsDetail.intro || '' }}
            ></p>
            {/* {newsDetail.image?.[0]?.url && (
              <div className="image">
                <img src={newsDetail.image?.[0]?.url || ''} loading="lazy" alt="" />
              </div>
            )} */}
            <p
              className="news-content"
              dangerouslySetInnerHTML={{ __html: newsDetail.content || '' }}
            ></p>
          </div>
        </div>
      );
    }
    return <></>;
  };

  return <>{renderNewsDetail()}</>;
};

export default NewsDetailV2;
